// NOTE: this is old code
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';

/**
 * The Purpose of SidebarLayout is strictly to fill the content's window from top to bottom, left to right with an additional sidebar.
 * This is great for when you want to create a scrolling window only within the content of the page,
 * or set an addtional background color the extends the remainder of the window.
 */

function SidebarLayout({ classes, children }) {
  let sidebar;
  let content = [];

  children.forEach(node => {
    if (!node) {
      return false;
    }

    if (node.type.skpName === 'Sidebar') {
      sidebar = node;
    } else {
      content.push(node);
    }
  });

  return (
    <div className={classes.root}>
      {sidebar}
      <div className={classes.sidebarContent}>{content}</div>
    </div>
  );
}

SidebarLayout.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
};

const styles = theme => {
  return {
    root: {
      overflowY: 'hidden',
      flex: '1 1 auto',
      display: 'flex',
    },
    sidebarContent: {
      flex: '1 1 auto',
    },
  };
};

export default withStyles(styles, { name: 'SkpSidebarLayout' })(SidebarLayout);
